export default "__VITE_ASSET__DJV98SbE__"